import React from "react";
import { observer } from "mobx-react";
import dashboardStore from "../../store/dashboardStore";
import styles from "../../styles/dashboard.module.css";
import commonStore from "../../../Store/marco/commonStore";
import { useTranslation } from "react-i18next";

export const SubPageSwitch = observer(() => {
  const store = dashboardStore;
  const cmStore = commonStore;
  const { t } = useTranslation("ActivityMain");

  // 你有兩個 sub tab：Decarbonization Roadmap / Environmental Performance
  const tabs = ["1) Decarbonization Roadmap", "2) Environmental Performance"];
  const handleSave = async () => {
    if (store.selectedSubTab === 0) {
      await store.updateDecarbonData();
      await store.getDecarbonData();
    } else if (store.selectedSubTab === 1) {
      await store.updateIntensityData();
    }
  };

  const handleChange = (i) => {
    cmStore.tryLeave(() => {
      store._handleSetSelectedSubTab(i);
    });
  };

  return (
    <div className={styles.subPageTitle}>
      {/* 左邊 Tabs */}
      <div className={styles.subTabBtnWrap}>
        {tabs.map((tab, index) => {
          const isActive = store.selectedSubTab === index;

          return (
            <div
              key={index}
              className={`${styles.subTabBtn} ${
                isActive ? styles.activeTab : styles.inActiveTab
              }`}
              onClick={() => {
                handleChange(index);
              }}
            >
              {t(tab)}
            </div>
          );
        })}
      </div>

      {/* 右邊 Save 按鈕 */}
      <div className={styles.subPageSaveBtn} onClick={handleSave}>
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="white"
          style={{ marginRight: "4px" }}
        >
          <path d="M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V7l-4-4zm0 16H5V5h11v4h4v10z" />
        </svg>
        {t("Save")}
      </div>
    </div>
  );
});
